import * as Response from './response'
import { MetricName, WeeklySummaryData, WeeklySummaryItem } from './types'

export function convertWeeklySummary(
  response: Response.WeeklySummary
): WeeklySummaryData {
  const summaryMetrics = response.metrics
  const lastWeek: WeeklySummaryItem[] = [{ body: 'lastWeek' }]
  const thisWeek: WeeklySummaryItem[] = [{ body: 'thisWeek' }]
  const trend: WeeklySummaryItem[] = [{ body: 'trend' }]
  const names: WeeklySummaryItem[] = []

  summaryMetrics.map(metric => {
    const isAmount = metric.name === 'totals' || metric.name === 'bonus'
    if (metric.name !== 'totals') {
      names.push({ body: convertMetricName(metric.name) })
    }

    lastWeek.push({ body: metric.last_week, isAmount })
    thisWeek.push({
      body: metric.current_week ?? metric.this_week,
      isBad: isBadMetric(metric),
      isAmount,
    })
    trend.push({ body: metric.trend, isAmount })
  })

  return { names, lastWeek, thisWeek, trend }
}

function convertMetricName(name: Response.MetricName): MetricName {
  switch (name) {
    case 'shifts':
      return 'shifts'
    case 'hrs':
      return 'hrs'
    case 'bonus':
      return 'bonus'
    case 'totals':
      return 'totals'
    case 'crew_scheduled':
      return 'crewScheduled'
    case 'crew_on_next':
      return 'crewOnNext'
    case 'shifts_scheduled':
      return 'shiftsScheduled'
    case 'labor_hours':
      return 'laborHours'
    case 'ot_hours':
      return 'otHours'
    case 'call_outs':
      return 'callOuts'
    case 'next_shifts':
      return 'nextShifts'
  }
}

export function isBadMetric(metric: Response.SummaryMetric): boolean {
  const isLower = metric.this_week < metric.last_week
  switch (metric.name) {
    case 'shifts':
      return isLower
    case 'hrs':
      return isLower
    case 'bonus':
      return isLower
    case 'totals':
      return isLower
    case 'crew_scheduled':
      return isLower
    case 'crew_on_next':
      return isLower
    case 'shifts_scheduled':
      return isLower
    case 'labor_hours':
      return isLower
    case 'ot_hours':
      return !isLower
    case 'call_outs':
      return !isLower
    case 'next_shifts':
      return isLower
  }
}
